module.exports = __webpack_public_path__ + "img/undraw_experience_design_eq3j.cb5725c0.svg";